import {EnvironmentImageRequestParams} from "../../models/image/environment-image-request-params";

export class VSImageRequestParams extends EnvironmentImageRequestParams {
  constructor(width, height, color) {
    super({width, height, color});

    this._resourceName = `/assets/vs`;
  }
}
